<template>
  <div
    class="grid grid-cols-1 gap-4"
    :class="gridClass"
    aria-busy="true"
    aria-label="Cargando resultados"
  >
    <div
      v-for="n in count"
      :key="n"
      class="animate-pulse rounded-xl border border-gray-100 bg-white overflow-hidden"
    >
      <div class="aspect-[4/3] bg-gray-200" />
      <div class="p-3 space-y-2">
        <div class="h-4 bg-gray-200 rounded w-3/4" />
        <div class="h-3 bg-gray-100 rounded w-1/2" />
        <div class="h-3 bg-gray-100 rounded w-2/3" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  count: { type: Number, default: 8 },
  columns: { type: Number, default: 4 },
})

const gridClass = computed(() => {
  if (props.columns >= 4) return 'lg:grid-cols-4'
  if (props.columns === 3) return 'lg:grid-cols-3'
  return 'lg:grid-cols-2'
})
</script>
